import { ReportEntityTypes } from '../../modules/reports/interfaces/header.interface';
import { lxAppApi } from '../../services/ApiController';
import { AsyncAction } from '../../services/apiMiddleware';
import { ExportAnswersResp } from '../../modules/companySettings/types';

import * as types from './action.types';

export const initExport = (
  type: string,
  subject: ReportEntityTypes,
  filters: Record<string, any>,
  sort: string,
  id?: string,
) => ({
  types: types.RequestExport,
  callAPI: () =>
    lxAppApi.post(`/api/exports/${subject}${subject !== ReportEntityTypes.Company && id ? `/${id}` : ''}`, {
      ...convertFilterNames(filters),
      sort,
      type,
    }),
  payload: { subject, id, type },
});

export const initTotalExport = (type: string) => ({
  types: types.RequestExport,
  callAPI: () => lxAppApi.post('/api/exports', { type }),
  payload: { type },
});

export const customInitExport = (): AsyncAction<ExportAnswersResp> => ({
  types: [
    types.GET_COMPANY_INIT_EXPORT_REQUEST,
    types.GET_COMPANY_INIT_EXPORT_SUCCESS,
    types.GET_COMPANY_INIT_EXPORT_FAILED,
  ],
  callAPI: () => lxAppApi.post('/api/exports'),
});

export const fetchExports = (entityType: ReportEntityTypes, status?: string, id?: string) => ({
  types: types.fetchExports,
  callAPI: () =>
    lxAppApi.get(
      `/api/v2/exports?filter.entity_type=${entityType}${!!status ? `&filter.status=${status}` : ''}${
        entityType !== ReportEntityTypes.Company && id ? `&filter.entity_id=${id}` : ''
      }`,
    ),
});

const convertFilterNames = (filters: Record<string, any>): Record<string, any> => {
  const renamedFilters: Record<string, any> = {};
  Object.keys(filters).forEach(k => {
    renamedFilters[k.toLowerCase().replace(/filter([^.])/, 'filter.$1')] = filters[k];
  });
  return renamedFilters;
};
